import { render } from "./coaches.vue?vue&type=template&id=5fe76dfa"
import script from "./coaches.vue?vue&type=script&lang=js"
export * from "./coaches.vue?vue&type=script&lang=js"

import "./coaches.vue?vue&type=style&index=0&id=5fe76dfa&lang=css"

import exportComponent from "C:\\Projects\\wld\\wlt-admin-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__